import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendMessageSource } from './backend-message.catalog';

@Injectable({ providedIn: 'root' })
export class BackendMessageI18nService {
  constructor(private translate: TranslateService) {}

  resolve(source: BackendMessageSource): string {
    const payload = this.extractPayload(source);
    if (payload.status) {
      const key = `BACKEND.CODE.${payload.status}`;
      const translated = this.translate.instant(key, payload.params ?? {});
      if (translated && translated !== key) {
        return translated;
      }
    }

    // Compatibilidad temporal con respuestas antiguas que solo envían message.
    if (payload.legacyText) {
      return payload.legacyText;
    }

    return this.translate.instant('BACKEND.MESSAGE.UNKNOWN');
  }

  private extractPayload(source: BackendMessageSource): {
    status: string | null;
    params: Record<string, unknown> | null;
    legacyText: string;
  } {
    if (source == null) {
      return { status: null, params: null, legacyText: '' };
    }

    if (typeof source === 'string') {
      return { status: null, params: null, legacyText: source };
    }

    if (source.respuesta && typeof source.respuesta === 'object') {
      return this.extractPayload(source.respuesta);
    }

    const status = this.normalizeCode(source.status ?? source.codigo);
    const params = this.normalizeParams(source.params);
    const legacyText =
      source.message ??
      source.responseError ??
      source.mensajeError ??
      source.mensajeExito ??
      source.text ??
      source.error ??
      '';

    return {
      status,
      params,
      legacyText: typeof legacyText === 'string' ? legacyText : String(legacyText ?? ''),
    };
  }

  private normalizeCode(raw: string | number | null | undefined): string | null {
    if (raw == null || raw === '') {
      return null;
    }
    return String(raw).trim();
  }

  private normalizeParams(raw: unknown): Record<string, unknown> | null {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
      return null;
    }
    return raw as Record<string, unknown>;
  }
}
